export class IdentidadPersonaDto {

    constructor(
        public tipoIdentificacion: string,
        public numeroIdentificacion: string,
        public primerNombre: string,
        public segundoNombre: string,
        public primerApellido: string,
        public segundoApellido: string,
        public fechaNacimiento: string,
    ){}

    public static objBeneficiarioARnc(obj: any){
        return new IdentidadPersonaDto(
            obj.tipoDocumento,
            obj.numeroDocumento,
            obj.primerNombre,
            obj.segundoNombre,
            obj.apellido,
            obj.segundoApellido,
            obj.fechaNacimiento,
        )
    }
    public static objConyugeARnc(obj: any){
        return new IdentidadPersonaDto(
            obj.TipoIdConyuge,
            obj.NumIdConyuge,
            obj.Nombre1Conyuge,
            obj.Nombre2Conyuge,
            obj.Apellido1Conyuge,
            obj.Apellido2Conyuge,
            obj.FechaNaciConyuge,
        )
    }

    public static objTrabajadorARnc(obj: any){
        return new IdentidadPersonaDto(
            obj.TipoIdTrabajador,
            obj.NumIdTrabajador,
            obj.Nombre1Trabajador,
            obj.Nombre2Trabajador,
            obj.Apellido1Trabajador,
            obj.Apellido2Trabajador,
            obj.FechaNaciTrabajador,
        )
    }
}